document.addEventListener('DOMContentLoaded', function () {
  // Définir la date et l'heure de la prochaine sortie
  var nextReleaseDate = new Date('2025-12-05T19:00:00+02:00'); // Remplacez cette date par la date de la prochaine sortie

  // Mettre à jour le compteur toutes les secondes
  var countdownInterval = setInterval(function () {
    var now = new Date();
    var timeRemaining = nextReleaseDate - now;

    if (timeRemaining <= 0) {
      clearInterval(countdownInterval);
      document.getElementById('countdown').textContent = "TARENTELLA PANT DROP AVAILABLE NOW";
    } else {
      // Calcul des jours, heures, minutes et secondes restantes
      var days = Math.floor(timeRemaining / (1000 * 60 * 60 * 24));
      var hours = Math.floor((timeRemaining / (1000 * 60 * 60)) % 24);
      var minutes = Math.floor((timeRemaining / (1000 * 60)) % 60);

      // Formatage du temps pour afficher comme "XX days XX hours XX minutes XX seconds"
      var timeString = days.toString().padStart(2, '0') + ' DAYS ' +
                       hours.toString().padStart(2, '0') + ' HOURS ' +
                       minutes.toString().padStart(2, '0') + ' MINUTES ';

      // Afficher le temps restant dans le span
      document.getElementById('countdown').textContent = timeString;
    }
  }, 1000); // Mettre à jour toutes les secondes
});
